import { createCallbackManager } from '$helper/functions/callbacks'
import { useState } from 'react'
import useEffectOnce from './use-effect-once'

const callbacks = createCallbackManager()

function createListener() {
  window
    .matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`)
    .addEventListener('change', callbacks.runCallbacks, { once: true })

  window.visualViewport?.addEventListener('resize', callbacks.runCallbacks, {
    once: true,
  })
}

export default function useDevicePixelRatio() {
  const [dpr, setDpr] = useState(
    window.devicePixelRatio * (window.visualViewport?.scale || 1),
  )

  useEffectOnce(() => {
    callbacks.addCallback(() => {
      if (window.visualViewport) {
        setDpr(window.devicePixelRatio * (window.visualViewport.scale || 1))
        return
      }

      setDpr(window.devicePixelRatio)
    })
  })

  return dpr
}

createListener()

// Set up new listener for the next `devicePixelRatio` change
callbacks.addCallback(createListener)
